import Section from "../Section";
import Parallax from '../global/Parallax';

export default class ImageWithTextOverlay extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const parallaxEl = element.querySelector('.parallax');
    if (parallaxEl) {
      this.parallax = new Parallax(theme, parallaxEl);
    }
  }
}
